import React from 'react';
import { Scrollbar } from '@fourthwall/components';
import * as S from './TooltipBox.styled';
export const TooltipBox = ({ children, size }) => (React.createElement(S.Container, { size: size },
    React.createElement(Scrollbar, { maxHeight: 256 }, children)));
